'use client'
import { useNavigation } from '@/context/NavigationContext'
import { getAssetUrl } from '@/utils/assetUtils'
import { useEffect, useState } from 'react'
import Button from '../Button'

export default function StartExperience() {
  const [animation, setAnimation] = useState<'fade-in' | 'fade-out' | ''>('')
  const { setLandingScreen, view, landingScreen } = useNavigation()

  const handleStartExperienceAction = () => {
    // AudioElement will handle intro/menu playback based on navigation state after interaction
    setAnimation('fade-out')

    setTimeout(() => {
      setLandingScreen('language') // Navigate to language selector
    }, 800) // Match the animation duration
  }

  useEffect(() => {
    if (landingScreen === 'splash') {
      setAnimation('fade-in')
    } else {
      setAnimation('fade-out')
    }
  }, [landingScreen])

  if (view !== 'landing') {
    return null // Don't render if not in landing view
  }

  return (
    <>
      {/* Splash */}
      <section className={`fixed inset-0 z-10 overflow-y-auto overflow-x-hidden bg-black ${animation}}`}>
        <div className={'flex flex-col items-center justify-between min-h-[100svh] sm:h-[100svh] container mx-auto'}>
          {/* Top spacing for desktop - approximately 30% from top */}
          <div className={'h-[10vh]'} />

          {/* Main content container */}
          <div
            className={
              'flex flex-col justify-between items-center max-h-[500px] h-[100svh] md:max-h-[70vh] px-4 text-center'
            }
          >
            <div>
              <picture className={'max-w-[85vw]'}>
                <source
                  media="(min-width: 768px)"
                  srcSet={getAssetUrl('/images/00-kaitiakitanfa-desktop.webp')}
                  type="image/webp"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet={getAssetUrl('/images/00-kaitiakitanfa-mobile.webp')}
                  type="image/webp"
                />
                <img
                  src={getAssetUrl('/images/00-kaitiakitanfa-desktop.webp')}
                  alt="Kaitiaki Tanfa"
                  className="w-full h-auto max-w-[85vw] lg:max-w-[50vw]"
                />
              </picture>

              {/* First paragraph directly under the image */}
              <p className={'font-medium text-white mt-16 text-xl md:text-3xl'}>An interactive 360 web experience</p>
            </div>
            {/* Button in the middle */}
            <div className={'mb-16 lg:mt-8'}>
              <Button onClick={handleStartExperienceAction}>Start experience</Button>
            </div>
          </div>

          {/* Footer paragraph */}
          <p className={'mb-4 opacity-50 text-center text-sm md:text-lg'}>Legal copy and acceptance of cookies etc.</p>
        </div>
      </section>
    </>
  )
}
